import store from './manager-store';
import routes from './manager-routes';

const components = [];
const mixins = [];
const filters = [];
const directives = [];

export default {
  components,
  mixins,
  filters,
  directives,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/entities/manager/manager-module.js